angular.module('cimerFrontEndApp').controller('PreviewSurveyModalCtrl', ['$scope', '$uibModalInstance', 'survey', function ($scope, $uibModalInstance, survey) {
    "use strict";
    $scope.survey = survey;

    $scope.close = function () {
        $uibModalInstance.dismiss('close');
    };

    $scope.printPreview = function () {
        // use jquery printThis plug in
        $("#print-surveyPreview").printThis();
    };
}]);